module.exports = __webpack_public_path__ + "fonts/SamsungOne-400C_v1.1.e4d8f56c.ttf";